import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelectorApp } from "../../lib/redux";
import { useDefaultAppRoute } from "../../hooks/useIsAdvertisersDemo";

const Error404 = () => {
  const navigate = useNavigate();
  const { user } = useSelectorApp((state) => state.auth);
  const defaultAppRoute = useDefaultAppRoute();

  useEffect(() => {
    user ? navigate(defaultAppRoute) : navigate("/login");
    // eslint-disable-next-line
  }, []);
  return <div>Error404</div>;
};

export default Error404;
